import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import qs from 'qs';
import { handleApiRequestSuccessData, handleRequestError } from '../../utils/request';
import { api } from '../index';
export var apiDownloadBrokerTierReport = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/brokers/broker-tier-report/excel?".concat(qs.stringify({
              start_month: payload.start_month,
              end_month: payload.end_month
            })), {
              responseType: 'blob'
            });

          case 3:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0, payload));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function apiDownloadBrokerTierReport(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiGetQuoteDailyReport = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.get("/admin/quotes/statistics/daily-report?".concat(qs.stringify(payload)));

          case 3:
            res = _context2.sent;
            handleApiRequestSuccessData(res);
            return _context2.abrupt("return", [res.data]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0, payload));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function apiGetQuoteDailyReport(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiDownloadPurchasedQuoteDailyReportExport = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.get("/admin/quotes/statistics/daily-report/export?".concat(qs.stringify(payload)), {
              responseType: 'blob'
            });

          case 3:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0, payload));

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function apiDownloadPurchasedQuoteDailyReportExport(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiDownloadBrokerMemberReport = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.get("/file_reports/broker-member-report/excel?".concat(qs.stringify(payload)), {
              responseType: 'blob'
            });

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", res);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0, payload));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function apiDownloadBrokerMemberReport(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiDownloadBrokerCohortReport = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.get("/admin/quotes/statistics/broker-cohort-report/export?".concat(qs.stringify(payload)), {
              responseType: 'blob'
            });

          case 3:
            res = _context5.sent;
            return _context5.abrupt("return", res);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0, payload));

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));

  return function apiDownloadBrokerCohortReport(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiDownloadBdxFinanceReport = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.get("/policies/admin/finance-report/export?".concat(qs.stringify({
              month: payload.month
            })), {
              responseType: 'blob'
            });

          case 3:
            res = _context6.sent;
            return _context6.abrupt("return", res);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", handleRequestError(_context6.t0, payload));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));

  return function apiDownloadBdxFinanceReport(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var apiCompareBdxFinanceReports = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return api.post('/policies/admin/finance-report/compare', payload.formData, {
              responseType: 'blob'
            });

          case 3:
            res = _context7.sent;
            return _context7.abrupt("return", res);

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", handleRequestError(_context7.t0, payload));

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 7]]);
  }));

  return function apiCompareBdxFinanceReports(_x7) {
    return _ref7.apply(this, arguments);
  };
}();